
import { defineComponent, computed, ref, watch } from 'vue'
import Sunmenu from '@/views/layout/submenu.vue'
import { useRoute } from 'vue-router'
import { RightOutlined, DownOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  props: {
    mode: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedKeys: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    Sunmenu,
    RightOutlined,
    DownOutlined
  },
  setup(props, context) {
    // data
    const selectedKey: any = ref()
    const openKey: any = ref()
    function handleClick(val: any) {
      context.emit('itemclick', val)
    }
    const route = useRoute()
    watch(
      () => props.selectedKeys,
      (val: any) => {
        selectedKey.value = []
        selectedKey.value = val
      }
    )
    watch(
      () => route.name,
      () => {
        const a = route.path.split('/page/')[1]
        openKey.value = a.split('/')
      },
      { deep: true }
    )
    return {
      handleClick,
      selectedKey,
      openKey
    }
  }
})
